import React from "react";
import "./index.css"
import Logo1 from '../images/pm_logo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from "../helpers";


const UserNotAllowed = () =>{
    const location = useLocation();
    const navigate = useNavigate()

    return(
        <div className="flex flex-column page-not-found  line-height-3">
            <p><img src={Logo1} alt="procmart" style={{ width: "250px", height: "40px" }} /></p>
            <div className="">
                <p className="mt-0"><span className="error-number text-xl">403.</span>&nbsp;&nbsp;<span className="text-xl text-color-secondary">Forbidden</span></p>
                <p className="mt-0 text-xl font-medium">You don't have permission to access this page</p>
                <Button className="small-btn mb-1"  label="Go To Home" onClick={() => navigate(`/`)}/>
            </div>
            
        </div>
    )
}

export default UserNotAllowed